
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ocean-pro-home-solar-battery",
      function () {
        return require("private-next-pages/ocean-pro-home-solar-battery/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ocean-pro-home-solar-battery"])
      });
    }
  